import hubChooserView from './hubChooserView.html';
import './hubChooser.css';

export default function hubChooserComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			model: '=',
			onChange: '&?',
			maxRows: '<?',
			flyoutLeft: '<?',
			flyoutRight: '<?',
		},
		controllerAs: 'vm',
		controller: hubChooserComponentCtrl,
		template: hubChooserView,
	};
}

class hubChooserComponentCtrl {
	constructor(Identity) {
		'ngInject';
		this.Identity = Identity;
	}

	$onInit() {
		// get the list of all hubs in account
		this.hubs = this.Identity.hubsInThisAccount();
		// Append "(this hub)" to the name of the current hub
		const currId = this.Identity.currentClient().id;
		for (const hub of this.hubs) {
			if (hub.id == currId) {
				hub.name += ' (this hub)';
				break;
			}
		}
	}
}
